// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"5cb3be5d","802":"1b2ae6eb"}[chunkId] + ".chunk.js";
};